/**
 * @generated SignedSource<<44984126aace2aa54cdbd142ef93fa19>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type utilsHubspotInfoQuery$variables = {};
export type utilsHubspotInfoQuery$data = {
  readonly viewer: {
    readonly account: {
      readonly benchmarkCompanySize: string | null;
      readonly hubspotOwner: {
        readonly email: string | null;
      } | null;
      readonly hubspotSegment: string | null;
    };
  };
};
export type utilsHubspotInfoQuery = {
  response: utilsHubspotInfoQuery$data;
  variables: utilsHubspotInfoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "benchmarkCompanySize",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "AccountHubSpotUserInfo",
  "kind": "LinkedField",
  "name": "hubspotOwner",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hubspotSegment",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "utilsHubspotInfoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "utilsHubspotInfoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "88e9c2be8fc34a58c509db02d91ea82e",
    "id": null,
    "metadata": {},
    "name": "utilsHubspotInfoQuery",
    "operationKind": "query",
    "text": "query utilsHubspotInfoQuery {\n  viewer {\n    account {\n      benchmarkCompanySize\n      hubspotOwner {\n        email\n      }\n      hubspotSegment\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "61dcc9b9a6c20cbae835a52abce98fa6";

export default node;
